import { render, staticRenderFns } from "./InvestmentTransactionProvider.vue?vue&type=template&id=32ed3c32"
import script from "./InvestmentTransactionProvider.vue?vue&type=script&lang=ts"
export * from "./InvestmentTransactionProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports